import React, { useMemo, useState } from 'react';
import StepWizard from 'react-step-wizard';
import map from 'lodash/map';
import styled from 'styled-components';

import AddEmailDomainStep1 from 'src/presentation/components/pages/email/components/AddEmailDomainStep1';
import AddEmailDomainStep2 from 'src/presentation/components/pages/email/components/AddEmailDomainStep2';
import AddEmailDomainStep3 from 'src/presentation/components/pages/email/components/AddEmailDomainStep3';
import EmailDomain from 'src/models/Email/EmailDomain';
import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { DomainError } from '@ad-scripts/application/lib/error';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { StepContainer } from './StepWizardLayout';

type AddEmailDomainModalType = {
  errors: DomainError[];
  handleCloseModal: () => void;
  emailDomain: EmailDomain | null;
  step: number;
};

const STEP_DATA_AID = 'add-email-domain-wizard-step-';

export default function AddEmailDomainModal({ step, errors, handleCloseModal, emailDomain }: AddEmailDomainModalType) {
  const [value, setValue] = useState<EmailDomain | null | undefined>(emailDomain);

  const steps = useMemo(
    () => ({
      step1: <AddEmailDomainStep1 errors={errors} setValue={setValue} onCancel={handleCloseModal} />,
      step2: <AddEmailDomainStep2 currentEmailDomain={value} />,
      step3: <AddEmailDomainStep3 onDone={handleCloseModal} />,
    }),
    [errors, setValue, handleCloseModal, value]
  );

  const getFormTitle = (step: number) => `Add sending domain - step ${step} of ${Object.keys(steps ?? {}).length}`;
  const [modalTitle, setModalTitle] = useState(getFormTitle(step));

  const handleStepChange = (stepChange: { previousStep: number; activeStep: number }) => {
    setModalTitle(getFormTitle(stepChange.activeStep));
  };

  const getModalContent = () => (
    <StyledStepWizard onStepChange={handleStepChange} initialStep={step}>
      {map(Object.values(steps), (step, index) => (
        <StepContainer key={index} data-aid={`${STEP_DATA_AID}${index + 1}`}>
          {step}
        </StepContainer>
      ))}
    </StyledStepWizard>
  );

  return (
    <EmbedModalWithGreenHeader
      data-aid="new-email-domain"
      title={modalTitle}
      modalSize={ModalSize.LARGE}
      content={getModalContent()}
      onCancel={handleCloseModal}
      disableOutsideClick={true}
    />
  );
}

const StyledStepWizard = styled(StepWizard)`
  overflow: hidden;
`;
